module.exports = __webpack_public_path__ + "static/media/lea_img_02.42c76802.jpg";